var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinghomeLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6659_9714)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#12263E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 96V416H248.701V315.429H296.41C327.762 315.429 354.116 304.914 375.472 283.429C396.828 261.943 407.733 236.343 407.733 205.714C407.733 175.086 396.828 149.486 375.472 128C354.116 106.514 327.762 96 296.41 96H176ZM248.701 246.857V164.571H296.41C318.675 164.571 335.033 182.4 335.033 205.714C335.033 229.029 318.675 246.857 296.41 246.857H248.701Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.067 399.933C687.978 462.069 687.978 561.487 624.067 625.398C561.931 687.534 462.513 687.534 398.602 625.398C336.466 561.487 336.466 462.069 398.602 399.933C462.513 336.022 561.931 336.022 624.067 399.933Z",
    fill: "#2B63E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0666 47.9334C111.978 110.069 111.978 209.487 48.0666 273.398C-14.0694 335.534 -113.487 335.534 -177.398 273.398C-239.534 209.487 -239.534 110.069 -177.398 47.9334C-113.487 -15.9778 -14.0694 -15.9778 48.0666 47.9334Z",
    fill: "#00C9BD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6659_9714"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinghomeLogo);
export default __webpack_public_path__ + "static/media/pinghome_logo.2e25b1efb5b3641f7d10b6865ff6639e.svg";
export { ForwardRef as ReactComponent };